import {ProgressSpinner} from 'primereact/progressspinner'
import React from 'react'


export const LoadingSpinner = (): JSX.Element => (
	<div className={'loading-spinner-wrapper'}>
		<ProgressSpinner className={'loading-spinner'} strokeWidth="5" animationDuration="2.4s"/>
	</div>
)


